export default __webpack_public_path__ + "static/media/product-desktop.449973ab.jpg";